import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { InHomeCareLicenseService } from "app/services/license/in-home-care/in-home-care-license.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class IhcParentNullableValidator implements AsyncValidator {
  constructor(private service: InHomeCareLicenseService){}

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
    return this.service.checkIfValidParentNullable(control.value).pipe(
      map(exists => (!exists ? { parentNotFound: true} : null )),
      catchError(() => of(null))
    )
  }
}
